import React from 'react';
import { BookingType, ServiceType } from 'utilities/enum-utils';
import { FaUserFriends, FaUsers, FaUserSlash } from 'react-icons/fa';
import { AiOutlineBook, AiFillHome } from 'react-icons/ai';
import { Center, ThemeIcon } from '@good/ui/core';

type IconType = ServiceType | 'ACTIVITY_RECORD';

interface IBookingTypeIconProps {
  size?: 'small' | 'default' | 'large';
  className?: string;
  type: IconType;
  style?: React.CSSProperties;
}

const BookingTypeIcon = ({ size = 'default', className, type, style = {} }: IBookingTypeIconProps) => {
  const getIcon = (type: IconType, className?: string, style?: React.CSSProperties) => {
    switch (type) {
      case ServiceType.GROUP:
        return <FaUsers className={className} />;
      case ServiceType.INDIVIDUAL:
        return <FaUserFriends className={className} />;
      case ServiceType.COORDINATION:
        return <AiOutlineBook className={className} />;
      case ServiceType.INDEPENDENT_LIVING:
        return <AiFillHome className={className} />;
      case BookingType.ACTIVITY_RECORD:
        return <FaUserSlash className={className} />;
      default:
        return <FaUserSlash className={className} />;
    }
  };

  const iconColor = {
    GROUP: 'lilac.3',
    INDIVIDUAL: 'green.3',
    COORDINATION: 'red',
    INDEPENDENT_LIVING: 'violet',
    ACTIVITY_RECORD: 'yellow',
  }[type];

  let size_ = 'sm';
  if (size === 'large') {
    size_ = 'md';
  } else if (size === 'small') {
    size_ = 'xs';
  }

  return (
    <ThemeIcon color={iconColor} variant='default' className={className} size={size_} c='gray.6'>
      <Center>{getIcon(type, '', style)}</Center>
    </ThemeIcon>
  );
};

export default BookingTypeIcon;
